import React, { useState, useRef, useEffect } from "react";
import "./SignUp.css";
import { Form, Col, Button, Spinner } from "react-bootstrap";
import AuthService from "../Services/auth.service";
import Select, { components } from "react-select";
import ServiceMember from "../../Member/Services/ServiceMember";
import { formatVilleToLabelValue } from "../../utils/utils";
import { Link } from "react-router-dom";
import Login from "../index";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

const SingleValue = ({ children, ...props }) => (
  <components.SingleValue {...props}>{children}</components.SingleValue>
);

const SignUp = (props) => {
  function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
  }
  const { history } = props;
  useEffect(() => {
    ServiceMember.getVille().then((res) => {
      setFormattedVille(res.data.map(formatVilleToLabelValue));
    });
  }, []);

  const [formattedVille, setFormattedVille] = useState();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [cin, setCin] = useState("");
  const [tel, setPhone] = useState("");
  const [adresse, setAdress] = useState("");
  const [city, setCity] = useState("");
  const [codePostal, setCodePostal] = useState("");
  const [username, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassWord] = useState("");
  //message error
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  //loading
  const [loading, setLoading] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const selectRef = useRef("");
  const clearCity = () => {
    setCity("");
    selectRef.current.select.clearValue();
  };

  // console.log(
  //   username,
  //   email,
  //   password,
  //   cin,
  //   firstName,
  //   lastName,
  //   tel,
  //   adresse,
  //   codePostal,
  //   city
  // );
  const HandleRegister = (e) => {
    e.preventDefault();
    // if (
    //   username == "" ||
    //   email == "" ||
    //   password == "" ||
    //   cin == "" ||
    //   firstName == "" ||
    //   lastName == "" ||
    //   tel == "" ||
    //   adresse == "" ||
    //   codePostal == "" ||
    //   city == ""
    // ) {
    //   setLoading(false);
    //   setOpen(true);
    //   setMessage("Tous les champs doivent etre non vide!");
    //   setSeverity("error");
    // }

    AuthService.register(
      email,
      password,
      cin,
      firstName,
      lastName,
      tel,
      adresse,
      codePostal,
      city
    ).then(
      (res) => {
        if (
          res.data.message.toString() ===
          "Un compte existe déja pour cette adresse email!"
        ) {
          setLoading(false);
          setMessage(res.data.message);
          setSeverity("error");
          setOpen(true);
        } else if (
          res.data.message.toString() === "votre compte a été crée avec succés"
        ) {
          setLoading(false);
          setMessage(res.data.message);
          setSeverity("success");
          setOpen(true);
          window.location.replace("/");
        }
      },
      (error) => {
        setLoading(false);
        setMessage("Une erreur est produite lors de la création du compte");
        setSeverity("error");
        setOpen(true);
      }
    );
  };

  return (
    <>
      <Snackbar open={open} autoHideDuration={5000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
      <form
        action="#"
        className="sign-up-form login"
        onSubmit={(e) => {
          setLoading(true);
          HandleRegister(e);
        }}
      >
        <h2 className="title"> S'INSCRIRE</h2>
        <div className="input-field">
          <input
            type="text"
            placeholder="Nom"
            required
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </div>

        <div className="input-field">
          <input
            type="text"
            placeholder="Prénom"
            required
            value={lastName}
            onChange={(e) => setLastName(e.target.value)}
          />
        </div>

        <div className="input-field">
          <input
            type="text"
            placeholder="CIN"
            required
            value={cin}
            onChange={(e) => setCin(e.target.value)}
          />
        </div>
        <div className="input-field">
          <input
            type="text"
            placeholder="Tel"
            required
            value={tel}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>
        <div className="input-field">
          <input
            type="text"
            placeholder="Adress"
            required
            value={adresse}
            onChange={(e) => setAdress(e.target.value)}
          />
        </div>

        <Select
          className="input-field"
          placeholder="Ville"
          width="90%"
          styles={{
            singleValue: (base) => ({
              ...base,
              padding: 5,
              borderRadius: 5,
              // background: "#0097e6",
              color: "black",
              display: "flex",
            }),
          }}
          ref={selectRef}
          components={{ SingleValue }}
          isSearchable
          isClearable
          name="label"
          required
          options={formattedVille}
          onChange={(formattedVille) => {
            formattedVille &&
              setCity({
                id: formattedVille.value,
                name: formattedVille.label,
              });
          }}
        />

        <div className="input-field">
          <input
            type="text"
            required
            placeholder="Code Postal"
            value={codePostal}
            onChange={(e) => setCodePostal(e.target.value)}
          />
        </div>

        <div className="input-field">
          <input
            type="email"
            placeholder="Email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="input-field">
          <input
            type="password"
            required
            placeholder="Password"
            value={password}
            onChange={(e) => setPassWord(e.target.value)}
          />
        </div>
        <div className="input-feild mt-2">
          <Form.Check
            name="conds"
            className="checkbox"
            required
            type="checkbox"
            label="Accepter les conditions"
          />
        </div>

        <button className="btn2 home" type="submit">
          Valider
        </button>
      </form>
      {loading ? (
        <div
          className="load"
          style={{ display: "inline-flex", margin: "0 auto 15px" }}
        >
          <Alert className="mr-2 w-30" severity="info">
            Attendez svp !
          </Alert>
          <Spinner animation="border" />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default SignUp;
